import { Helmet } from 'react-helmet';
import { useState, useEffect } from 'react';
import {
  Box,
  Container,
  Grid
} from '@material-ui/core';


//My Components
import MaxAmount from 'src/components/dashboard/user/MaxAmount';
import MaxRate from 'src/components/dashboard/user/MaxRate';
import MaxTerm from 'src/components/dashboard/user/MaxTerm';
import CreditLevel from 'src/components/dashboard/user/CreditLevel';
import LoanHistory from 'src/components/dashboard/user/RecentLoans';
import DueDates from 'src/components/dashboard/user/DueDate';
import Requirements from 'src/components/dashboard/user/Requirements';
import Wallet from 'src/components/dashboard/user/Wallet';
import LoanStatus from 'src/components/dashboard/user/LoanStatus';



//Redux
import { useSelector, useDispatch } from "react-redux";
import { SET_BACKBTN } from 'src/redux/actions/types';


const Dashboard = () => {
  const { user } = useSelector(state => state.auth);
  const dispatch = useDispatch();
  const [status, setStatus] = useState({});
  const [loanTerm, setLoanTerm] = useState({});
  const [loans, setLoan] = useState([]);

  const [unVer, setVer] = useState(false);
  
  const dueDates = []
  useEffect(() => {
  
    if(user && user.loanTerm){
      setLoanTerm(user.loanTerm);
    }

    if(user && user.loans){
      setLoan(user.loans);
    }

    if(user && user.status){
        let stat = [];
      let { requirements } = user.status;
      requirements && requirements.forEach(a => {
        if(!a.isPass){
          setVer(true);
          stat.push(a);
        }
      })
      setStatus(stat)
    }

  }, [user])


  useEffect(() => {
    dispatch({
      type: SET_BACKBTN,
      payload: null
    })
  }, [])


 
  let payable = loans.find(a => !a.isPaid && a.status === 'Approved');

  return (
  <>
    <Helmet>
      <title>Dashboard | Transac</title>
    </Helmet>
    <Box
      sx={{
        backgroundColor: 'background.default',
        minHeight: '100%',
        py: 3
      }}
    >
      <Container maxWidth={false}>
       <Grid
          container
          spacing={3}
        >
             <Grid
            item
            lg={4}
            sm={12}
            xl={4}
            xs={12}
          >
            <Wallet data={user ? user : {}} />
          </Grid>
          <Grid
            item
            lg={4}
            sm={12}
            xl={4}
            xs={12}
          >
          {payable ?  <LoanStatus data={payable ? payable : {}} /> :
            <MaxAmount data={loanTerm} />
          }
          </Grid>
        
         
          {/* <Grid
            item
            lg={3}
            sm={6}
            xl={3}
            xs={12}
          >
            <MaxTerm week={loanTerm.weeklyTerm} sm={loanTerm.smTerm} />
          </Grid> */}
          {/* <Grid
            item
            lg={3}
            sm={6}
            xl={3}
            xs={12}
          >
            <MaxRate week={loanTerm.weeklyRate} sm={loanTerm.smRate}  />
          </Grid> */}
          <Grid
            item
            lg={4}
            sm={12}
            xl={4}
            xs={12}
          >
            <CreditLevel />
          </Grid>
          {dueDates.length !== 0 &&
          <Grid
            item
            lg={4}
            md={6}
            xl={3}
            xs={12}
          >
            <DueDates dueDates={dueDates} />
          </Grid>
            }
       {unVer &&  <Grid
            item
            lg={4}
            md={6}
            xl={3}
            xs={12}
          >
        <Requirements requirements={status}/>
          </Grid>}
          {loans.length !== 0 && <Grid
            item
            lg={8}
            md={12}
            xl={9}
            xs={12}
          >
            <LoanHistory loans={loans} />
          </Grid>}
        </Grid> 
      </Container>
    </Box>
  </>
);
    }

export default Dashboard;
